import { httpClient } from '@infrastructure/api/client'
import { ENDPOINTS } from '@infrastructure/api/endpoints'
import type { ReleaseManifest } from '@domain/entities/ReleaseManifest'

interface ApiResponse<T> {
  success: boolean
  data: T
}

export async function fetchRelease(): Promise<ReleaseManifest> {
  const res = await httpClient.get<ApiResponse<ReleaseManifest>>(ENDPOINTS.RELEASE)
  return res.data
}
